export default __webpack_public_path__ + "static/media/fw-sophia-er-Rose Gold.25332448.mp4";